import type { ComponentType } from 'react';
import type { IntlShapeV2 as IntlShape } from '@atlassian/jira-intl/src/v2/types.tsx';
import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import {
	getUnresolvedIssuesInVersionJql,
	getResolvedIssuesInVersionJql,
} from '../../services/urls.tsx';
import {
	getName,
	getProjectKey,
	getDoneIssuesCount,
	getUnresolvedIssuesCount,
	getResolvedIssuesCount,
} from '../../state/selectors.tsx';
import { ReleaseAutomationBanner } from './release-automation-banner/ReleaseAutomationBanner.tsx';
import ReleaseDate from './release-date/index.tsx';
import SwapIssues from './swap-issues/index.tsx';
import Content from './view.tsx';

export type StateProps = {
	readonly unresolvedIssuesCount: number;
	readonly resolvedIssuesCount: number;
	readonly unresolvedIssuesUrl: string;
	readonly resolvedIssueUrl: string;
	readonly doneIssues: number;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	readonly SwapIssues: ComponentType<Record<any, any>>;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	readonly ReleaseDate: ComponentType<Record<any, any>>;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	readonly ReleaseAutomationBanner: ComponentType<Record<any, any>>;
};

export type OwnProps = {
	readonly intl: IntlShape;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const mapStateToProps = (state: any): StateProps => ({
	SwapIssues,
	ReleaseDate,
	ReleaseAutomationBanner,
	doneIssues: getDoneIssuesCount(state),
	unresolvedIssuesCount: getUnresolvedIssuesCount(state),
	resolvedIssuesCount: getResolvedIssuesCount(state),
	unresolvedIssuesUrl: getUnresolvedIssuesInVersionJql(getProjectKey(state), getName(state)),
	resolvedIssueUrl: getResolvedIssuesInVersionJql(getProjectKey(state), getName(state)),
});

export default connect(mapStateToProps, {})(Content);
